import type { ChangeEvent } from "react";
import { TextField } from "@mui/material";

interface TextInputProps {
  label: string;
  value: string;
  type?: string;
  error?: boolean;
  disabled?: boolean;
  helperText?: string;
  placeholder?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const TextInput = ({
  label,
  value,
  onChange,
  type = "text",
  placeholder,
  error = false,
  helperText = "",
  disabled = false
}: TextInputProps) => {
  return (
    <TextField
      variant="standard"
      fullWidth
      label={label}
      value={value}
      onChange={onChange}
      type={type}
      placeholder={placeholder}
      error={error}
      helperText={helperText}
      disabled={disabled}
    />
  );
};
